<template>
  <section id="servicos" class="section-shaped m-0 bg-default py-0">
    <div class="row row-grid justify-content-center py-5">
      <h1 class="text-white">Serviços</h1>
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="row">
            <div
              v-for="(servico, index) in servicos"
              v-bind:key="index"
              class="card-group col-lg-4 col-sm-12 col-md-6 mb-5"
              :class="servico.class"
            >
              <card class="border-0" hover shadow body-classes="py-3">
               <div class="text-center">
                 <icon :name="servico.icone" type="dark" rounded class="mb-4">
                 </icon>
               </div>
                <h6 class="text-dark text-uppercase">{{ servico.nome }}</h6>
                <p class="description mt-3 text-justify">{{ servico.descricao }}</p>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name: 'SectionServicos',
    data(){
      return {
        servicos: [
          {
            "nome":"Integração por meio de WebServices",
            "descricao":"Serviço voltado para empresas credenciadas à emissão de Nota Fiscal de Serviços Eletrônica junto a prefeitura do seu municipio e que possuem seus próprios sistemas. É possível realizar a integração com o Portal Janela Única por meio de WebServices.",
            "icone":"ni ni-spaceship"
          },
          {
            "nome":"Funcionamento Totalmente Via Internet",
            "descricao":"O Portal Janela Única é um sistema on-line destinado à Emissão da Nota Fiscal de Serviços Eletrônica e ao controle de arrecadação de todas as receitas municipais, tais como: IPTU, ISS QN, Vigilância Sanitária, ITBI, Aluguel de Próprios Municipal, Taxa e Tarifas Diversas, Certidões, Auditorias, etc.",
            "icone":"ni ni-world-2"
          },
          {
            "nome":"Rígido Controle de Acesso",
            "descricao":"Há um rígido controle de acesso e permissões para o manuseio do sistema. Para cada operador são configuradas as respectivas permissões e restrições. Além disso, todas as movimentações cadastrais realizadas são armazenadas em um histórico.",
            "icone":"ni ni-badge"
          },
          {
              "nome":"Telas Padronizadas e Fácil Utilização",
              "descricao":"O sistema possui telas padronizadas contendo títulos e figuras intuitivas que facilitam sua utilização. Para o seu manuseio são necessários apenas os conhecimentos básicos de informática e das tarefas corriqueiras do Departamenteo de Tributos.",
              "icone":"ni ni-tie-bow"
          },
          {
              "nome":"Integração Cadastral",
              "descricao":"Cada contribuinte tem cadastro único no sistema, tornando possível a rápida exibição, por exemplo, de um único extrato com pagamentos e débitos, englobando todas as receitas e inscrições que possam ter relação com o respectivo contribuinte.",
              "icone":"ni ni-archive-2"
          },
          {
            "nome":"Estatísticas em Gráficos e Relatórios",
            "descricao":"São disponibilizados vários gráficos e relatórios referentes aos cadastros, aos lançamentos de tributos e a arrecadação em todos os períodos. Todos os lançamentos devedores são apresentados com as devidas correções monetárias, multas e juros em conformidade com a legislação tributária municipal.",
            "icone":"ni ni-chart-bar-32"
          },
          {
            "nome":" Autosserviços para a Comunidade",
            "descricao":"Através do Portal Janela Única, as prefeituras poderão disponibilizar autosserviços para a comunidade, tais como: consulta de autenticidade de documentos, certidões negativas, emissão de segunda via de DAMs, etc.",
            "icone":"ni ni-spaceship",
            "class": 'offset-lg-4 offset-md-3 offset-sm-0'
          }
        ]
      }
    }
  };
</script>
